import React from 'react'
import TeaserLiftSection from '../organisms/TeaserLiftSection'

const M06TeaserLift = ({ lifts, anchorLinkId }) => {
  return (
    <section className="my-10 md:my-32 lg:my-64" id={anchorLinkId}>
      <div className="container space-y-32 lg:space-y-64">
        {lifts.map(lift => (
          <TeaserLiftSection key={lift.id} lift={lift} />
        ))}
      </div>
    </section>
  )
}

export default M06TeaserLift
